module.exports = __webpack_public_path__ + "static/vr-illustration-916730b965530219b9f63e0b44b46fee.png";